import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

function DefaultTabList({ tabList = [], activeValue = [], handleActive }) {

    const [activeTab, setActiveTab] = useState(tabList[0]?.value);
    const [isMobile, setIsMobile] = useState(false);

    // 브라우저 너비 감지
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile(); // 최초 실행
        window.addEventListener('resize', checkMobile); // 리사이즈 대응

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        setActiveTab(activeValue);
    }, [activeValue, tabList]);

    const handleTabClick = (tab) => {
        setActiveTab(tab.value);
        handleActive(tab);
    };

    return (
        <div className="tab_wrapper">
            {isMobile ? (
                <div className="tab_swiper border_con">
                    <Swiper
                        className="tab_list"
                        slidesPerView="auto"
                        freeMode={true}
                        slideToClickedSlide={true}
                        centeredSlidesBounds={true}
                    >
                        {tabList.map((tab) => (
                            <SwiperSlide
                                key={tab.value}
                                className={`tab_item tab_mo ${activeTab === tab.value ? 'active' : ''}`}
                                onClick={() => handleTabClick(tab)}
                            >
                                <button
                                    type="button"
                                    className="flex-center-4 flex-justify-center"
                                >
                                    {tab.name}
                                </button>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            ) : (
                <div className="border_con">
                    <ul className="tab_list">
                        {tabList.map((tab) => (
                            <li
                                key={tab.value}
                                className={`tab_item ${activeTab === tab.value ? 'active' : ''}`}
                                onClick={() => handleTabClick(tab)}
                            >
                                <button
                                    type="button"
                                    className="flex-center-4 flex-justify-center"
                                >
                                    {tab.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default DefaultTabList;
